// NOTE: Temporary solution until further notice https://git.eonbit.com/eontyre/webshop/-/issues/317
export const isShowBadge = (productName, brandName, siteId) => {
    return (
            productName.toLowerCase().includes('x-ice') ||
            productName.toLowerCase().includes('x ice')
        ) && 
        brandName.toLowerCase() === 'michelin' &&
        siteId === 486
}
